import React, {useRef} from 'react';
import {motion, useInView} from 'framer-motion';

import styles from './styles/about-04.module.css';

import {ReactComponent as BookImg} from '../../assets/about04/book.svg';
import {ReactComponent as ClockImg} from '../../assets/about04/clock.svg';
import {ReactComponent as GraduateImg} from '../../assets/about04/graduate.svg';

const environmentBoxMotion = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3
        }
    }
};

const environmentItemMotion = {
    hidden: {
        opacity: 0,
        y: 100
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            stiffness: 400,  // 클수록 빠름
            damping: 50,     // 작을수록 더 통통 튐
            mass: 0.5        // 작을수록 가볍고 빠름
        }
    }
};

const voiceBoxMotion = {
    hidden: {
        opacity: 0,
        y: 100
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            stiffness: 400,  // 클수록 빠름
            damping: 50,     // 작을수록 더 통통 튐
            mass: 0.5,       // 작을수록 가볍고 빠름
            delay: 0.9
        }
    }
};


const slideMotion = {
    x: ["0%", "-50%"],
    transition: {
        x: {
            repeat: Infinity,
            repeatType: 'loop',
            duration: 80,
            ease: 'linear',
            delay: 1.2
        }
    },
};

export default function About04() {
    const ref = useRef(null);
    
    const isInView = useInView(ref, {
        once: true,
        amount: 0.5,
        margin: '-100px 0px'
    });

    const environmentMap = [
        { id: 1, Img: GraduateImg, title: '전문가 팀', content: '9년차 AI 개발자 3인을 중심으로 한 10인의 개발팀' },
        { id: 2, Img: ClockImg, title: '유연한 근무', content: '매주 수요일 재택근무와 유연출근제(8~10시) 운영' },
        { id: 3, Img: BookImg, title: '학습 지원', content: '사내 스터디 및 업무 관련 교육 지원' }
    ];

    const voiceMap = [
        { 
            id: 1, 
            voice: '각자의 전문성을 인정하며, 자율적으로 일하면서도 필요할 때는 언제든 도움을 주고받을 수 있어요. 이런 환경 덕분에 매일 새로운 도전을 할 수 있는 것 같습니다.',
            member: 'AI 개발자 김00'
        },
        { 
            id: 2, 
            voice: 'AI 챗봇 디자인을 하다 보면 어려운 상황이 많이 생겨요. 하지만 그런 순간마다 팀원들과 함께 머리를 맞대고 해결책을 찾으려고 할 때가 정말 재미있습니다. 서로의 의견을 나누고 피드백을 주고받으면서 점점 더 나은 결과물이 나오는 걸 보면 보람을 느끼고 기쁩니다.',
            member: '프로덕트 디자이너 박00'
        },
        { 
            id: 3, 
            voice: '사용자 중심의 인터페이스를 구현하며 마주치는 도전들이 저를 성장시키고 우리가 만드는 각각의 화면이 사용자에게 가치를 전달할 때마다 보람을 느낍니다. 또한, 신뢰와 존중이 가득한 문화 속에서 저의 꿈과 회사의 비전이 하나가 될 수 있는 환경에서 일할 수 있어 즐겁습니다.',
            member: '프론트 개발자 임00'
        },
        { 
            id: 4, 
            voice: '각자의 전문성을 인정하며, 자율적으로 일하면서도 필요할 때는 언제든 도움을 주고받을 수 있어요. 이런 환경 덕분에 매일 새로운 도전을 할 수 있는 것 같습니다.',
            member: 'AI 개발자 정00'
        },
        { 
            id: 5, 
            voice: 'AI 기술을 단순한 도구가 아닌, 사람들의 일터에서 매일의 어려움을 덜어주고 효율적인 업무 환경을 만들어가는 정보사회의 따뜻한 동료라고 생각합니다. 우리가 개발하는 챗봇과 솔루션은 기술적인 혁신을 넘어, 각자의 업무에 작은 여유와 큰 성취감을 선사했으면 좋겠습니다.',
            member: '백엔드 개발자 송00'
        }
    ];

    return (
        <div className={styles.wrapper}>
            <div className={styles.container} ref={ref}>
                <p className={styles.title}>Our Culture & People</p>
                <div className={styles.boxKeyword}>
                    <p className={styles.keyword}>업무 환경</p>
                    <motion.div
                        className={styles.environmentList}
                        initial='hidden'
                        animate={isInView ? 'visible' : 'hidden'}
                        variants={environmentBoxMotion}
                    >
                        {environmentMap.map(({ id, Img, title, content }) => (
                            <motion.div
                                className={styles.boxEnvironment} 
                                key={id}
                                variants={environmentItemMotion}
                            >
                                <div><Img /></div>
                                <div className={styles.boxText}>
                                    <p>{title}</p>
                                    <p>{content}</p>
                                </div>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
                <div className={styles.boxKeyword}>
                    <p className={styles.keyword}>팀원들의 목소리</p>
                    <motion.div
                        initial='hidden'
                        animate={isInView ? 'visible' : 'hidden'}
                        variants={voiceBoxMotion}
                    >
                        <motion.div
                            className={styles.voiceList}
                            animate={slideMotion}
                        >
                            {voiceMap.map(({ id, voice, member }) => (
                                <div className={styles.boxVoice} key={id}>
                                    <p>{voice}</p>
                                    <p>{member}</p>
                                </div>
                            ))}
                            {voiceMap.map(({ id, voice, member }) => (
                                <div className={styles.boxVoice} key={id}>
                                    <p>{voice}</p>
                                    <p>{member}</p>
                                </div>
                            ))}
                            {voiceMap.map(({ id, voice, member }) => (
                                <div className={styles.boxVoice} key={id}>
                                    <p>{voice}</p>
                                    <p>{member}</p>
                                </div>
                            ))}
                        </motion.div>
                    </motion.div>
                </div>
            </div>
        </div>
    );
}
